import { useQuery } from '@apollo/client/react'
import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { PileNodeConnection } from '@src/generated/schema'
import { Pile } from '@src/graphql/Pile'
import debounce from 'lodash.debounce'
import { MultiSelect } from '@src/components/Elements/MultiSelect'
import { MultiSelectProps } from '@src/components/Elements/MultiSelect/MultiSelect'

export const WoodtypeSelect: FC<Pick<MultiSelectProps, 'required'>> = (props) => {
  const { t } = useTranslation()
  const { data, loading, fetchMore, refetch } = useQuery<{ woodtypes: PileNodeConnection }>(Pile.getPileWoodtypes, {
    variables: {
      first: 10,
    },
    fetchPolicy: 'network-only',
  })
  const { woodtypes: { edges } = { edges: [] as any } } = data || {}

  const handleSearch = useCallback(
    debounce((value: string) => {
      refetch({
        first: 10,
        woodtype_Icontains: value,
      })
    }, 100),
    [],
  )

  const handlePopupScroll = (e: any) => {
    e.persist()
    const scrollTop = e.target.scrollTop as number
    const offsetHeight = e.target.offsetHeight as number

    if (scrollTop + offsetHeight === e.target.scrollHeight) {
      fetchMore({
        variables: {
          after: data?.woodtypes.pageInfo.endCursor,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const newEdges = fetchMoreResult.woodtypes.edges
          const pageInfo = fetchMoreResult.woodtypes.pageInfo

          return newEdges.length
            ? {
                woodtypes: {
                  pageInfo,
                  __typename: prev.woodtypes.__typename,
                  edges: [...prev.woodtypes.edges, ...newEdges],
                },
              }
            : prev
        },
      })
    }
  }

  return (
    <MultiSelect
      {...props}
      label={t('desktop.pages.piles.filter.woodtype')}
      options={edges.map(({ node: { woodtype } }) => ({
        title: woodtype,
        value: woodtype,
      }))}
      name='woodtype'
      loading={loading}
      onSearch={handleSearch}
      onPopupScroll={handlePopupScroll}
    />
  )
}
